import { DOCUMENT } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@ngneat/transloco';
import { CUSTOM_ELEMENTS_SCHEMA, Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, LoadingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  constructor(private analyticsService: AnalyticsService) {
    this.analyticsService.init();
    const document = inject(DOCUMENT);
    inject(TranslocoService).langChanges$.pipe(takeUntilDestroyed()).subscribe(lang => {
      document.documentElement.lang = lang;
    });
  }
}
